/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Full sync status serializer including error text fields.  Use only when error fields are loaded (i.e. not deferred), such as the single-appointment detail endpoint.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface SyncStatusDetail { 
    readonly videoCallStatus: string;
    readonly zohoCreatorStatus: string;
    readonly emailStatus: string;
    readonly webhookStatus: string;
    readonly cancellationStatus: string;
    retryCount: number;
    nextRetryAt: string | null;
    adminNotified: boolean;
    isSyncing: boolean;
    hasFailedSteps: boolean;
    isFullySynced: boolean;
    videoCallError: string;
    zohoCreatorError: string;
    emailError: string;
    webhookError: string;
    cancellationError: string;
}
export const SyncStatusDetail_videoCallStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_zohoCreatorStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_emailStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_webhookStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_cancellationStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_retryCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_nextRetryAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_adminNotified_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_isSyncing_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_hasFailedSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_isFullySynced_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_videoCallError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_zohoCreatorError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_emailError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_webhookError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusDetail_cancellationError_Validators: ValidatorFn[] =
    [  Validators.required, ];


